import React from 'react';
import {iconName, qualify} from '@packages/systems/wfdl-Qualified';
import {Atom, Plugins} from '@packages/systems/wfdl';
import {createDevlinkAtom} from '@packages/utilities/integrated-types';

const FormFileUploadFileName = Atom.createRender(
  ({attributes, classes, generateAttributes}) => {
    const updatedClasses = classes.push('w-file-upload-file-name');
    const fileName = 'fileuploaded.jpg';

    return (
      <div {...generateAttributes(attributes, updatedClasses)}>{fileName}</div>
    );
  }
);

const config = createDevlinkAtom({
  displayName: 'Text Block',
  icon: {
    type: 'Component',
    value: qualify(Plugins.name('Basic'), iconName('Text')),
  },
  showEmpty: false,
  render: FormFileUploadFileName,
  fields: {},
});

export default config;
